import { ERROR_BRANDING_NOT_FOUND } from '@features/branding-edit/constants';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetBrandingResponse, GetBrandingsResponse } from '@responses/brandings';
import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { normaliseBranding } from '../utils';

import type { QueryFactory } from './factory.types';

export type BrandingType = GetBrandingsResponse[number];

export const fetchBrandings = async (): Promise<BrandingType[]> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/brandings',
  });

  const { data } = await axios(networkPayload);
  return data.map(normaliseBranding<BrandingType>);
};

export const fetchBrandingDetails = async (brandingId: string): Promise<GetBrandingResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: '/brandings/' + brandingId,
  });

  const { data } = await axios(networkPayload);

  if (!data) {
    throw new Error(ERROR_BRANDING_NOT_FOUND);
  }

  return normaliseBranding<GetBrandingResponse>(data);
};

export const brandingQueries = {
  list: () =>
    queryOptions({
      queryKey: ['brandings', 'list'] as const,
      queryFn: fetchBrandings,
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: ['brandings', 'detail', id] as const,
      queryFn: () => fetchBrandingDetails(id),
    }),
} satisfies QueryFactory;

export function useBrandings() {
  return useQuery(brandingQueries.list());
}
